<!-- ================首页-美育五馆====================-->
<template>
    <div class="full-screen-container">
        <home-head />
        <div class="home-container">
            <div class="museum-container">
                <div class="my-museum-container">
                    <div class="museum-item-container">
                        <div class="museum-item" @click="handleMuseumNavigate('/museum/read')">
                            <div class="item-container-25">
                                <img class="item-container-img" src="../../assets/image/ydtzg.png" alt="阅读拓展馆">
                            </div>
                            <div class="item-container-15 font-1">
                                阅读拓展馆
                            </div>
                            <div class="item-container-10 font-2">
                                以阅读为根 启智润心
                            </div>
                            <div class="item-container-20 font-3">
                                多元阅读资源 养成终身习惯
                            </div>
                            <div class="item-container-10 ">
                                <div class="hum-item">
                                    配套阅读资源
                                </div>
                            </div>
                            <div class="item-container-10 mt8">
                                <div class="hum-item">
                                    书香润心营
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="museum-item-container">
                        <div class="museum-item" @click="handleMuseumNavigate('/museum/technology')">
                            <div class="item-container-25">
                                <img class="item-container-img" src="../../assets/image/kxysg.png" alt="科学艺术馆">
                            </div>
                            <div class="item-container-15 font-1">
                                科学艺术馆
                            </div>
                            <div class="item-container-10 font-2">
                                以审美为形 融真创关
                            </div>
                            <div class="item-container-20 font-3">
                                习得艺术特长 全员成果展演
                            </div>
                            <div class="item-container-10 ">
                                <div class="hum-item">
                                    艺术特长资源
                                </div>
                            </div>
                            <div class="item-container-10 mt8">
                                <div class="hum-item">
                                    科艺启心营
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="museum-item-container">
                        <div class="museum-item" @click="handleMuseumNavigate('/museum/intangible')">
                            <div class="item-container-25">
                                <img class="item-container-img" src="../../assets/image/fywhg.png" alt="非遗文化馆">
                            </div>
                            <div class="item-container-15 font-1">
                                非遗文化馆
                            </div>
                            <div class="item-container-10 font-2">
                                以文化为魂 守正创新
                            </div>
                            <div class="item-container-20 font-3">
                                触摸千年文脉 建立文化自信
                            </div>
                            <div class="item-container-10 ">
                                <div class="hum-item">
                                    非遗实践资源
                                </div>
                            </div>
                            <div class="item-container-10 mt8">
                                <div class="hum-item">
                                    非遗匠心营
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="museum-item-container" @click="handleMuseumNavigate('/museum/labor')">
                        <div class="museum-item">
                            <div class="item-container-25">
                                <img class="item-container-img" src="../../assets/image/ldsjg.png" alt="劳动实践馆">
                            </div>
                            <div class="item-container-15 font-1">
                                劳动实践馆
                            </div>
                            <div class="item-container-10 font-2">
                                以实践为基 砺行成长
                            </div>
                            <div class="item-container-20 font-3">
                                习得劳动技能 培养责任担当
                            </div>
                            <div class="item-container-10 ">
                                <div class="hum-item">
                                    劳动实践资源
                                </div>
                            </div>
                            <div class="item-container-10 mt8">
                                <div class="hum-item">
                                    劳趣砺心营
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="museum-item-container">
                        <div class="museum-item"  @click="handleMuseumNavigate('/museum/educational')">
                            <div class="item-container-25">
                                <img class="item-container-img" src="../../assets/image/yxtyg.png" alt="研学体验馆">
                            </div>
                            <div class="item-container-15 font-1">
                                研学体验馆
                            </div>
                            <div class="item-container-10 font-2">
                                以体验为径 知行合一
                            </div>
                            <div class="item-container-20 font-3">
                                线上预热 线下实地探索
                            </div>
                            <div class="item-container-10 ">
                                <div class="hum-item">
                                    研学配套资源
                                </div>
                            </div>
                            <div class="item-container-10 mt8">
                                <div class="hum-item">
                                    研学悟心营
                                </div>
                            </div>
                        </div>
                    </div>

                </div>

                <div class="my-source-container">
                    <div class="source-item-container">
                        <div class="source-item cursor" @click="handleMuseumNavigate('/edu/eduResearch')">
                            <div class="source-item-img">
                                <img class="img-100" alt="活动竞赛" src="../../assets/image/hdjs.png">
                            </div>
                            <div class="source-item-title1">活动竞赛</div>
                            <div class="source-item-title2">赛事报名 成果展示</div>
                        </div>
                    </div>

                    <div class="source-item-container">
                        <div class="source-item cursor" @click="handleMuseumNavigate('/premium/resource')">
                            <div class="source-item-img">
                                <img class="img-100" alt="优质资源" src="../../assets/image/yzzy.png">
                            </div>
                            <div class="source-item-title1">优质资源</div>
                            <div class="source-item-title2">分龄资源 可看可下</div>
                        </div>
                    </div>

                    <div class="source-item-container">
                        <div class="source-item cursor" @click="handleMuseumNavigate('/tea/teaResearch')">
                            <div class="source-item-img">
                                <img class="img-100" alt="名师教研" src="../../assets/image/msjy.png">
                            </div>
                            <div class="source-item-title1">名师教研</div>
                            <div class="source-item-title2">专业指导 美育赋能</div>
                        </div>
                    </div>

                    <div class="source-item-container">
                        <div class="source-item cursor" @click="handleMuseumNavigate('/edu/excursion')">
                            <div class="source-item-img">
                                <img class="img-100" alt="营在规划" src="../../assets/image/yzgh.png">
                            </div>
                            <div class="source-item-title1">营在规划</div>
                            <div class="source-item-title2">沉浸研学 一键预约</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <home-footer />
    </div>
</template>

<script>
import homeHead from "@/components/common/homeHead.vue";
import homeFooter from "@/components/common/homeFooter.vue";
export default {
    components: {homeHead,homeFooter},
    name: "museumHome",
    data() {
        return {
        }
    },
    computed: {},
    watch: {},
    created() {
    },
    mounted() {},
    methods: {
        handleMuseumNavigate(path){
            if (!this.$storage.get("token")) {
                this.$confirm("您查看的内容需要登录，是否继续？", "温馨提示", {
                    confirmButtonText: "去登录",
                    cancelButtonText: "取消",
                    type: "success"
                }).then(() => {
                    //跳转登录页
                    this.$router.push("/museum/login");
                }).catch(()=>{})
                return;
            }
            this.$router.push(path)
        },
    },
}
</script>
<style>
.home-container{
    width: 100%;
    height: calc(100vh - 280px);
    background-color: #fdfcf8;
    display: flex;
    justify-content: center;
    align-items: center;
}
.museum-container{
    width: 1200px;
    height: calc(100vh - 340px);
}
.my-museum-container{
    width: 100%;
    height: calc(67vh - 230px);
    padding-bottom: 10px;
    box-sizing: border-box;
    display: flex;
}
.museum-item-container{
    width: 20%;
    height: calc(67vh - 240px);
    display: flex;
    align-items: center;
    justify-content: center;
}
.museum-item{
    width: 94%;
    height: calc(67vh - 280px);
    border: 1px solid #b22222;
    cursor: pointer;
}
.item-container-20{
    width: 90%;
    height: 16%;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: auto;
    border-top: .5px solid #f3f4f6;
    margin-top: 2%;
    margin-bottom: 2%;
}
.item-container-25{
    width: 100%;
    height: 25%;
    display: flex;
    justify-content: center;
    align-items: center;
}
.item-container-img{
    width: auto;
    height: 80%;
    display: flex;
}
.item-container-15{
    width: 100%;
    height: 15%;
    display: flex;
    justify-content: center;
    align-items: center;
}
.item-container-10{
    width: 100%;
    height: 10%;
    display: flex;
    justify-content: center;
    align-items: center;
}
.font-1{
    font-size: 15px;
    font-weight: bold;
    color: #333333;
    font-family: sans-serif;
}
.font-2{
    font-size: 12px;
    color: #b22222;
}
.font-3{
    font-size: 12px;
    color: #b3b2b4;
}
.hum-item{
    width: 90%;
    height: 80%;
    border: 1px solid #d4af37;
    border-radius: 3px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 13px;
    color: #d4af37;
    padding: 2px 0 2px 0;
}
.my-source-container{
    width: 100%;
    height: calc(33vh - 110px);
    display: flex;
    padding-top: 10px;
    box-sizing: border-box;
}
.source-item-container{
    width: 25%;
    height: calc(33vh - 120px);
    display: flex;
    align-items: center;
    justify-content: center;
}
.source-item{
    width: 80%;
    height: 120px;
    padding: 5px 0 5px 0;
    box-sizing: border-box;
    cursor: pointer;
}
.source-item-img{
    width: 54px;
    height: 54px;
    margin: auto;
}
.source-item-title1{
    width: 100%;
    height: 30px;
    text-align: center;
    line-height: 30px;
    font-size: 16px;
    color: #333;
    font-weight: bold;
    font-family: sans-serif;

}
.source-item-title2{
    width: 100%;
    height: 20px;
    text-align: center;
    line-height: 15px;
    font-size: 13px;
    color: #6b7280;
    font-family: sans-serif;
}
</style>